import { SvgIcon, SvgIconProps } from '@mui/material';

const CheckedCredit = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_9474_16973)">
          <mask
            id="mask0_9474_16973"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="20"
            height="20"
          >
            <path d="M0.0649414 1.21591H19.937V20.8288H0.0649414V1.21591Z" fill="white" />
          </mask>
          <g mask="url(#mask0_9474_16973)">
            <path
              d="M19.0168 12.6148C19.1112 12.0757 19.9374 11.5888 19.9374 11.0228C19.9374 10.4565 19.1112 9.96961 19.0168 9.43012C18.9198 8.87569 19.5285 8.13635 19.3402 7.61925C19.1488 7.09298 18.2062 6.91824 17.9297 6.43982C17.6504 5.95699 17.9691 5.0524 17.6128 4.62793C17.2552 4.20177 16.3102 4.35954 15.8847 4.00158C15.4606 3.64497 15.4524 2.68541 14.9699 2.40582C14.4922 2.12929 13.6582 2.59957 13.1326 2.4082C12.6158 2.21988 12.2803 1.32073 11.7265 1.22368C11.188 1.12936 10.5664 1.85785 10.0012 1.85785C9.43553 1.85785 8.81426 1.12936 8.27579 1.22368C7.72204 1.32073 7.38613 2.21988 6.86937 2.4082C6.34378 2.59957 5.50977 2.12895 5.03203 2.40582C4.54988 2.68541 4.54173 3.64497 4.11726 4.00158C3.69211 4.35954 2.74681 4.20177 2.38952 4.62793C2.03325 5.0524 2.35152 5.95699 2.07227 6.43982C1.79574 6.91824 0.853147 7.09298 0.661779 7.61925C0.473804 8.13635 1.08218 8.87569 0.985137 9.43012C0.89081 9.96961 0.0649414 10.4565 0.0649414 11.0228C0.0649414 11.5888 0.89081 12.0757 0.985137 12.6148C1.08218 13.1693 0.473804 13.9089 0.661779 14.426C0.853147 14.9523 1.79574 15.1267 2.07227 15.6051C2.35152 16.0883 2.03325 16.9925 2.38952 17.4174C2.74681 17.8435 3.69177 17.6857 4.11726 18.0434C4.54173 18.4003 4.54954 19.3599 5.03203 19.6395C5.50977 19.9163 6.34378 19.4454 6.86937 19.6371C7.38613 19.8254 7.7217 20.7242 8.27579 20.8213C8.81426 20.9159 9.43553 20.1874 10.0012 20.1874C10.5664 20.1874 11.188 20.9159 11.7265 20.8213C12.2803 20.7242 12.6158 19.8254 13.1326 19.6371C13.6582 19.4454 14.4919 19.9163 14.9699 19.6395C15.4524 19.3599 15.4606 18.4003 15.8847 18.0434C16.3102 17.6857 17.2552 17.8435 17.6128 17.4174C17.9691 16.9929 17.6504 16.0883 17.9297 15.6051C18.2062 15.1267 19.1488 14.9523 19.3402 14.426C19.5285 13.9089 18.9198 13.1693 19.0168 12.6148Z"
              fill="#84C61C"
            />
          </g>
          <path
            d="M7.71013 14.6982L4.98347 11.772C4.79719 11.583 4.73374 11.1005 4.99467 10.7514C5.20606 10.4691 5.87008 10.3066 6.22363 10.576C6.23449 10.5841 8.4851 12.3309 8.4851 12.3309C8.48714 12.3329 8.49019 12.3329 8.49223 12.3309L13.5384 7.6057C13.8885 7.25486 14.4552 7.25045 14.8114 7.59518C15.1752 7.94738 15.1809 8.52963 14.8243 8.88929L9.26957 14.7006C8.83967 15.1342 8.13867 15.1332 7.71013 14.6982Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_9474_16973">
            <rect width="20" height="20" fill="white" transform="translate(0 0.955292)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default CheckedCredit;
